import {Routing} from 'nutshell-core/routing';
import type {SavedFilter, SavedListType} from 'nutshell-core/types';

export function getSavedListSearch(
    savedList: SavedFilter<SavedListType>,
    targetBaseUrl: string,
    currentBaseUrl: string
) {
    let savedListSearch = `?list=${savedList.id}&${savedList.value}`;

    if (targetBaseUrl === currentBaseUrl) {
        // Replace the saved view parameter with the current view
        // (don't want to change the view when someone loads up a saved list)
        const deparamedSavedListValue = Routing.deparam(savedList.value);
        deparamedSavedListValue.view = Routing.deparam(
            window.location.search.replace(/^\?/, '')
        ).view;
        savedListSearch = `?list=${savedList.id}&${Routing.param(deparamedSavedListValue)}`;
    }

    return savedListSearch;
}
